import { useEffect } from 'react';

import { FARE_ATTRIBUTES } from '@web-platform/shared-universal-constants/src/queryParams';
import { fareAttributesFilterChanged } from '@web-platform/shared-universal-redux/src/actions/detailsPanel';
import { mapSearchParamToFilterState } from '@web-platform/shared-universal-utils-frontend/src/helpers/fareAttributes/mappers';
import { useSearchParam } from '@web-platform/shared-universal-utils-frontend/src/helpers/hooks/useFareAttributesSearchParam';
import { useDispatch } from 'react-redux';

export const useSyncFareAttributeFiltersWithLocation = () => {
  const dispatch = useDispatch();
  const [filterParam] = useSearchParam({ key: FARE_ATTRIBUTES });

  useEffect(() => {
    dispatch(fareAttributesFilterChanged(mapSearchParamToFilterState(filterParam)));
  }, [dispatch, filterParam]);
};
